module.exports = __webpack_public_path__ + "static/media/Slide7.f8c16ee9.jpg";